import api from './axiosConfig';
import {
  PublicRegistrationContext,
  RegistrationRequest,
  RegistrationRequestDetail,
  SendRegistrationOtpRequest,
  SendRegistrationOtpResult,
  SubmitRegistration,
  VerifyRegistrationOtpRequest,
  VerifyRegistrationOtpResult,
} from '../types';

export const registrationApi = {
  getPublicContext: async (tenantId: string): Promise<PublicRegistrationContext> => {
    const response = await api.get<PublicRegistrationContext>('/public-registration/context', { params: { tenantId } });
    return response.data;
  },

  sendRegistrationOtp: async (data: SendRegistrationOtpRequest): Promise<SendRegistrationOtpResult> => {
    const response = await api.post<SendRegistrationOtpResult>('/public-registration/send-otp', data);
    return response.data;
  },

  verifyRegistrationOtp: async (data: VerifyRegistrationOtpRequest): Promise<VerifyRegistrationOtpResult> => {
    const response = await api.post<VerifyRegistrationOtpResult>('/public-registration/verify-otp', data);
    return response.data;
  },

  getAll: async (status?: string): Promise<RegistrationRequest[]> => {
    const params: any = {};
    if (status) params.status = status;
    const response = await api.get<RegistrationRequest[]>('/employees/registration-requests', { params });
    return response.data;
  },

  getById: async (id: string): Promise<RegistrationRequestDetail> => {
    const response = await api.get<RegistrationRequestDetail>(`/employees/registration-requests/${id}`);
    return response.data;
  },

  submit: async (data: SubmitRegistration): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/employees/registration-requests', data);
    return response.data;
  },

  approve: async (requestId: string): Promise<{ employeeId: string }> => {
    const response = await api.post<{ employeeId: string }>('/employees/registration-requests/approve', { requestId });
    return response.data;
  },

  reject: async (requestId: string, reason: string): Promise<void> => {
    await api.post('/employees/registration-requests/reject', { requestId, reason });
  },
};
